<template>
    <div class="my-panel-tasks-wrapper">
        <div class="my-panel-task-header">
            <h2>{{ __('Today\'s events') }}</h2>
            <v-button :label="__('Calendar of consultations and my availability')" modal-target="modal-availability-calendar" size="sm" variant="secondary"></v-button>

            <my-panel-task-filters @change="changeFilter"></my-panel-task-filters>
        </div>

        <template v-if="loading">        
            <div slot="spinner" class="loader-wrapper">
                <img src="imgs/vitadio-loader.svg" alt="">
            </div>
        </template>
        
        <template v-else>
            <template v-if="tasks.today || tasks.future">
                <my-panel-task-list
                    :coach="coach"
                    :tasks="tasks.today"
                ></my-panel-task-list>

                <my-panel-task-list
                    :coach="coach"
                    :tasks="tasks.future"
                    type="future"
                ></my-panel-task-list>
            </template>

            <template v-else>
                <figure class="my-panel-task-no-patients--img">
                    <span class="material-icons-round">event_busy</span>
                </figure>
                <p class="my-panel-task-no-patients--text">{{ __("You have no events today or in the future") }}</p>
            </template>
        </template>
    </div>
</template>

<script>
import MyPanelTaskList from './MyPanelTaskList.vue'
import MyPanelTaskFilters from './MyPanelTaskFilters.vue'
export default {
    components: {
        MyPanelTaskList,
        MyPanelTaskFilters
    },
    props: {
        coach: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tasks: {
                today: null,
                future: null
            },
            loading: true,
            orderBy: 'all'
        }
    },
    computed: {

    },
    mounted() {
        this.fetchTasks()
    },
    methods: {
        async fetchTasks() {
            setTimeout(() => {
                axios
                    .get(`/my-panel?filter=${this.orderBy}`)
                    .then(async ({ data }) => {
                        this.tasks = data

                        this.loading = false
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            }, 350)
        },
        changeFilter(params) {
            this.loading = true
            this.orderBy = params.order
            this.fetchTasks()
        }
    }
}
</script>
